import React, { useState } from "react";
import {
  Grid,
  Box,
  ListItemIcon,
  ListItemText,
  Collapse,
  Chip,
} from "@mui/material";
import BadgeIcon from "@mui/icons-material/Badge";
import { ListItem, ListItemButton } from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ChildYoungPerson from "./clinical_info_tab/child_young_person";
import ProblemsAndDiagnoses from "./clinical_info_tab/problems_and_diagnoses";
import PregnancyBirthHistory from "./clinical_info_tab/pregnancy_bith_history";
import FamilyMedicalHistory from "./clinical_info_tab/family_medical_history";
import ImmunizationHistory from "./clinical_info_tab/immunization_history";
import DevelopmentalHistory from "./clinical_info_tab/developmental_history";
import SafeguardingIssues from "./clinical_info_tab/safeguarding_issues";
import { pcolor } from "../../style2";

export default function ClinicalInformation(props) {

  //const patient = useSelector((state) => state.patient.value);

  const [openChildYoungPerson, setOpenChildYoungPerson] = useState(false);
  const [openProblemsAndDiagnoses, setOpenProblemsAndDiagnoses] = useState(false);
  const [openPregnancyAndBirthHistory, setOpenPregnancyAndBirthHistory] = useState(false);
  const [openFamilyMedicalHistory, setOpenFamilyMedicalHistory] = useState(false);
  const [openImmunizationHistory, setOpenImmunizationHistory] = useState(false);
  const [openDevelopmentalHistory, setOpenDevelopmentalHistory] = useState(false);
  const [openSafeguardingIssues, setOpenSafeguardingIssues] = useState(false);

  

  const isImmunizationHistoryEmpty = () => {
    if (props.profile.maternalBirthHistory === null)
      return true;
    if (props.profile.maternalBirthHistory?.immunizationsHistory && props.profile.maternalBirthHistory?.immunizationsHistory !== "")
      return false;
    return true;
  }

  const isFamilyMedicalHistoryEmpty = () => {
    if (props.profile.familyInformation === null)
      return true;
    if (props.profile.familyInformation?.familyIllnessesHistory && props.profile.familyInformation?.familyIllnessesHistory !== "")
      return false;
    return true;
  }
  const isPregnancyAndBirthHistoryEmpty = () => {
    let profile = props.profile;
    if (profile.maternalBirthHistory === null)
      return true;
    if (profile.maternalBirthHistory?.prenatalHistory && profile.maternalBirthHistory?.prenatalHistory !== "")
      return false;
    if (profile.maternalBirthHistory?.maternalHealthDuringPregnancy && profile.maternalBirthHistory?.maternalHealthDuringPregnancy !== "")
      return false;
    if (profile.maternalBirthHistory?.birthHistory && profile.maternalBirthHistory?.birthHistory !== "")
      return false;
    if (profile.maternalBirthHistory?.gestationalAgeAtDelivery && profile.maternalBirthHistory?.gestationalAgeAtDelivery !== "")
      return false;
    if (profile.maternalBirthHistory?.deliveryType && profile.maternalBirthHistory?.deliveryType !== "")
      return false;
    if (profile.maternalBirthHistory?.babyWeight && profile.maternalBirthHistory?.babyWeight !== "")
      return false;

    if (profile.maternalBirthHistory?.neonatalHistory && profile.maternalBirthHistory?.neonatalHistory !== "")
      return false;
    if (profile.maternalBirthHistory?.hospitalHistorySinceBirth && profile.maternalBirthHistory?.hospitalHistorySinceBirth !== "")
      return false;
    if (profile.maternalBirthHistory?.feedingHistory && profile.maternalBirthHistory?.feedingHistory !== "")
      return false;

    return true;
  }

  const isProblemAndDiagnosisEmpty = () => {
    let profile = props.profile;
    if (profile.userDiagnosisList === null && profile.clinicalInformation === null)
      return true;
    if (profile.userDiagnosisList?.filter(t => !t.isOtherProblems).length > 0)
      return false;
    if (profile.userDiagnosisList?.filter(t => t.isOtherProblems === true).length > 0 && profile.userDiagnosisList?.filter(t => t.isOtherProblems === true)[0].title !== "")
      return false;
    if (profile.clinicalInformation?.backgroundHistory && profile.clinicalInformation?.backgroundHistory !== "")
      return false;
    if (profile.clinicalInformation?.activeProblems && profile.clinicalInformation?.activeProblems !== "")
      return false;
    if (profile.clinicalInformation?.currentManagement && profile.clinicalInformation?.currentManagement !== "")
      return false;

    if (profile.clinicalInformation?.treatmentGoals && profile.clinicalInformation?.treatmentGoals !== "")
      return false;
    if (profile.clinicalInformation?.orthoticsEquipment && profile.clinicalInformation?.orthoticsEquipment !== "")
      return false;
    if (profile.clinicalInformation?.keyInterventions && profile.clinicalInformation?.keyInterventions !== "")
      return false;

    return true;
  }

  const isDevelopmentalHistoryEmpty = () => {
    let profile = props.profile;
    if (profile.childDevelopmentList !== null && profile.childDevelopmentList.length > 0)
      return false;

    if (profile.user?.gmfcLevel !== 0)
      return false;

    return true;
  }

  const isSafeGaurdingIssuesEmpty = () => {
    if (props.profile.childSafeGuarding !== null)
      return false;

    return true;
  }

  const isChildYoungPersonEmpty = () => {
    let profile = props.profile;
    if (profile.user?.height !== null && profile.user?.height !== "")
      return false;
    if (profile.user?.weight !== null && profile.user?.weight !== "")
      return false;
    if (profile.user?.bloodGroup !== null && profile.user?.bloodGroup !== "" && profile.user?.bloodGroup !== "Not Known")
      return false;
    return true;
  }
  return (
        <Grid container>
          <Grid item sm={12}>
            <Box m={2}>
              <ListItem>
                <ListItemButton disabled={isChildYoungPersonEmpty()} onClick={() => setOpenChildYoungPerson(!openChildYoungPerson)}
                  sx={{ color: pcolor, borderBottom: "0.1px solid grey" }}>
                  <ListItemIcon>
                    <BadgeIcon sx={{ color: pcolor }} />
                  </ListItemIcon>
                  <ListItemText primary={<>Child or Young person's Height / Weight / Blood Group {isChildYoungPersonEmpty() ? <Chip label="No data provided" size="small" /> : null}</>} />
                  {openChildYoungPerson ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
              </ListItem>
            </Box>
            <Collapse in={openChildYoungPerson} timeout='auto' unmountOnExit>
              <Box style={{ padding: "0px 15px" }}>
                <ChildYoungPerson profile={props.profile} />
              </Box>
            </Collapse>
            <Box m={2}>
              <ListItem>
                <ListItemButton disabled={isProblemAndDiagnosisEmpty()}
                  onClick={() => setOpenProblemsAndDiagnoses(!openProblemsAndDiagnoses)}
                  sx={{ color: pcolor, borderBottom: "0.1px solid grey" }} >
                  <ListItemIcon>
                    <BadgeIcon sx={{ color: pcolor }} />
                  </ListItemIcon>
                  <ListItemText primary={<>Problems and Diagnoses {isProblemAndDiagnosisEmpty() ? <Chip label="No data provided" size="small" /> : null}</>} />
                  {openProblemsAndDiagnoses ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
              </ListItem>
            </Box>
            <Collapse in={openProblemsAndDiagnoses} timeout='auto' unmountOnExit >
              <Box style={{ padding: "0px 15px" }}>
                <ProblemsAndDiagnoses profile={props.profile} />
              </Box>
            </Collapse>
            <Box m={2}>
              <ListItem>
                <ListItemButton disabled={isPregnancyAndBirthHistoryEmpty()} onClick={() =>
                  setOpenPregnancyAndBirthHistory(!openPregnancyAndBirthHistory)
                } sx={{ color: pcolor, borderBottom: "0.1px solid grey" }} >
                  <ListItemIcon>
                    <BadgeIcon sx={{ color: pcolor }} />
                  </ListItemIcon>
                  <ListItemText primary={<>Pregnancy and Birth History {isPregnancyAndBirthHistoryEmpty() ? <Chip label="No data provided" size="small" /> : null}</>} />
                  {openPregnancyAndBirthHistory ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
              </ListItem>
            </Box>
            <Collapse in={openPregnancyAndBirthHistory} timeout='auto' unmountOnExit>
              <Box style={{ padding: "0px 15px" }}>
                <PregnancyBirthHistory profile={props.profile} />
              </Box>
            </Collapse>
            <Box m={2}>
              <ListItem>
                <ListItemButton disabled={isFamilyMedicalHistoryEmpty()} onClick={() =>
                  setOpenFamilyMedicalHistory(!openFamilyMedicalHistory)
                } sx={{ color: pcolor, borderBottom: "0.1px solid grey" }} >
                  <ListItemIcon>
                    <BadgeIcon sx={{ color: pcolor }} />
                  </ListItemIcon>
                  <ListItemText primary={<>Family medical history {isFamilyMedicalHistoryEmpty() ? <Chip label="No data provided" size="small" /> : null}</>} />
                  {openFamilyMedicalHistory ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
              </ListItem>
            </Box>
            <Collapse in={openFamilyMedicalHistory} timeout='auto' unmountOnExit>
              <Box style={{ padding: "0px 15px" }}>
                <FamilyMedicalHistory profile={props.profile} />
              </Box>
            </Collapse>
            <Box m={2}>
              <ListItem>
                <ListItemButton disabled={isImmunizationHistoryEmpty()}
                  onClick={() => setOpenImmunizationHistory(!openImmunizationHistory)}
                  sx={{ color: pcolor, borderBottom: "0.1px solid grey" }}>
                  <ListItemIcon>
                    <BadgeIcon sx={{ color: pcolor }} />
                  </ListItemIcon>
                  <ListItemText primary={<>Immunization history {isImmunizationHistoryEmpty() ? <Chip label="No data provided" size="small" /> : null}</>} />
                  {openImmunizationHistory ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
              </ListItem>
            </Box>
            <Collapse in={openImmunizationHistory} timeout='auto' unmountOnExit>
              <Box style={{ padding: "0px 15px" }}>
                <ImmunizationHistory profile={props.profile} />
              </Box>
            </Collapse>
            <Box m={2}>
              <ListItem>
                <ListItemButton disabled={isDevelopmentalHistoryEmpty()} onClick={() => setOpenDevelopmentalHistory(!openDevelopmentalHistory)}
                  sx={{ color: pcolor, borderBottom: "0.1px solid grey" }} >
                  <ListItemIcon>
                    <BadgeIcon sx={{ color: pcolor }} />
                  </ListItemIcon>
                  <ListItemText primary={<>Developmental history {isDevelopmentalHistoryEmpty() ? <Chip label="No data provided" size="small" /> : null}</>} />
                  {openDevelopmentalHistory ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
              </ListItem>
            </Box>
            <Collapse in={openDevelopmentalHistory} timeout='auto' unmountOnExit>
              <Box style={{ padding: "0px 15px" }}>
                <DevelopmentalHistory profile={props.profile} />
              </Box>
            </Collapse>
            <Box m={2}>
              <ListItem>
                <ListItemButton disabled={isSafeGaurdingIssuesEmpty()} onClick={() => setOpenSafeguardingIssues(!openSafeguardingIssues)}
                  sx={{ color: pcolor, borderBottom: "0.1px solid grey" }}>
                  <ListItemIcon>
                    <BadgeIcon sx={{ color: pcolor }} />
                  </ListItemIcon>
                  <ListItemText primary={<>Safeguarding issues {isDevelopmentalHistoryEmpty() ? <Chip label="No data provided" size="small" /> : null}</>} />
                  {openSafeguardingIssues ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
              </ListItem>
            </Box>
            <Collapse in={openSafeguardingIssues} timeout='auto' unmountOnExit>
              <Box style={{ padding: "0px 15px" }}>
                <SafeguardingIssues profile={props.profile} />
              </Box>
            </Collapse>
          </Grid>
          <Box m={2} />
        </Grid>
  );
}
